module.exports = __webpack_public_path__ + "img/a1.c4e51b5a.png";